import { render, staticRenderFns } from "./WinRates.vue?vue&type=template&id=da1a4c00&scoped=true&"
import script from "./WinRates.vue?vue&type=script&lang=ts&"
export * from "./WinRates.vue?vue&type=script&lang=ts&"
import style0 from "./WinRates.vue?vue&type=style&index=0&id=da1a4c00&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1a4c00",
  null
  
)

export default component.exports